<template>
  <div>
    <sideTree :search-data="searchData" />
  </div>
</template>
<script>
import sideTree from './sideTree'
export default {
  components: {
    sideTree
  },
  props: {
    data: {
      type: Array,
      default: () => {
        return []
      }
    },
    searchData: {
      type: String,
      default: () => {
        return null
      }
    }
  },
  data () {
    return {}
  },
  computed: {
    active () {
      return this.$route.path
    }
  },
  methods: {
    handleSelect (index) { // 导航选中事件
      this.$emit('select', index)
    },
    handleOpen (index) { // 导航展开事件
      this.$emit('open', index)
    },
    handleClose (index) { // 导航收起事件
      this.$emit('close', index)
    }
  }
}
</script>
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/left-side/side-nav.vue